import React, { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { DashboardLayer } from "../../../shared/dashboardLayer/DashboardLayer";
import { GlobalLoader } from "../../../shared/loaders/globalLoader/GlobalLoader";
import { Page404 } from "../../../pages/page404/Page404";
import Reports from "../../../pages/reports/Reports";
import AuditOnsiteList from "../../../pages/audits/auditOnsiteLIst/AuditOnsiteList";
import AuditOnSite from "../../../pages/audits/auditOnSite/AuditOnSite";

const Clients = lazy(() => import("../../../pages/clients/Clients"));
const Auditors = lazy(() => import("../../../pages/auditors/Auditors"));
const Employees = lazy(() => import("../../../pages/employees/Employees"));
const Library = lazy(() => import("../../../pages/library/Library"));
const Checklists = lazy(() => import("../../../pages/checklists/Checklists"));
const Resources = lazy(() => import("../../../pages/resources/Resources"));
const AskExpert = lazy(() => import("../../../pages/askExpert/AskExpert"));
const AskExpertDetails = lazy(
  () => import("../../../pages/askExpert/askExpertDetails/AskExpertDetails")
);
const Logout = lazy(() => import("../../../pages/auth/logout/Logout"));
const Newsletter = lazy(() => import("../../../pages/newsletter/Newsletter"));
const ChangePassword = lazy(
  () => import("../../../pages/auth/changePassword/ChangePassword")
);
const ActionList = lazy(
  () => import("../../../pages/audits/actionList/ActionList")
);
const Action = lazy(() => import("../../../pages/audits/action/Action"));
const SingleComment = lazy(
  () => import("../../../pages/audits/actionList/singleComment/SingleComment")
);
const Home = lazy(() => import("../../../pages/home/Home"));
const PrivacyPolicy = lazy(
  () => import("../../../pages/privacyPolicy/PrivacyPolicy")
);
const TermsOfUse = lazy(() => import("../../../pages/termsOfUse/TermsOfUse"));

export const RoutesAdmin = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <Home />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/clients"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <Clients />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/settings"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <ChangePassword />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/client/:clientId/library"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <Library />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/client/:clientId/employees"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <Employees />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/client/:clientId/controls/check-lists"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <Checklists />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/client/:clientId/controls/resources"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <Resources />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/client/:clientId/controls/reports"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <Reports />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/client/:clientId/audits-onsite"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <AuditOnsiteList />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/client/:clientId/audits-onsite/:auditOnSiteId"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <AuditOnSite />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/client/:clientId/action-list"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <ActionList />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/client/:clientId/action-list/:actionId"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <Action />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/client/:clientId/action-list/:actionId/comment/:commentId"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <SingleComment />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/auditors"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <Auditors />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/library"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <Library />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/newsletter"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <Newsletter />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/ask-expert"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <AskExpert />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/ask-expert/:id"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <AskExpertDetails />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/logout"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <Logout />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/privacy-policy"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <PrivacyPolicy />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/terms-of-use"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <TermsOfUse />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/change-password/:token"
        element={
          <Suspense fallback={<GlobalLoader />}>
            <ChangePassword />
          </Suspense>
        }
      />
      <Route
        path="*"
        element={
          <DashboardLayer>
            <Page404 />
          </DashboardLayer>
        }
      />
    </Routes>
  );
};
